import { Link } from "react-router-dom"
import { RefreshCw, Plus, ArrowLeft } from "lucide-react"
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"

interface AdminPageHeaderProps {
  title: string
  subtitle?: string
  loading?: boolean
  onRefresh?: () => void
  createHref?: string
  createLabel?: string
  onCreate?: () => void
  actions?: React.ReactNode
  /** 顯示「返回上一層」按鈕，點下會 navigate 到此 href */
  backHref?: string
  /** 自訂返回按鈕的 aria-label / tooltip（預設「返回」） */
  backLabel?: string
}

export function AdminPageHeader({
  title,
  subtitle,
  loading,
  onRefresh,
  createHref,
  createLabel,
  onCreate,
  actions,
  backHref,
  backLabel = "返回",
}: AdminPageHeaderProps) {
  return (
    <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-3 min-w-0">
        {backHref && (
          <Button
            asChild
            variant="outline"
            size="icon"
            className="shrink-0"
            aria-label={backLabel}
            title={backLabel}
          >
            <Link to={backHref}>
              <ArrowLeft className="h-4 w-4" />
            </Link>
          </Button>
        )}
        <div className="min-w-0">
          <h1 className="text-xl font-semibold text-foreground truncate">{title}</h1>
          {subtitle && <p className="mt-0.5 text-sm text-muted-foreground truncate">{subtitle}</p>}
        </div>
      </div>
      <div className="flex items-center gap-2">
        {actions}
        {onRefresh && (
          <Button variant="outline" size="icon" onClick={onRefresh}>
            <RefreshCw className={cn("h-3.5 w-3.5", loading && "animate-spin")} />
          </Button>
        )}
        {createHref && (
          <Button asChild>
            <Link to={createHref}>
              <Plus className="h-4 w-4" />
              {createLabel || "新增"}
            </Link>
          </Button>
        )}
        {onCreate && !createHref && (
          <Button onClick={onCreate}>
            <Plus className="h-4 w-4" />
            {createLabel || "新增"}
          </Button>
        )}
      </div>
    </div>
  )
}
